// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import MUIDialog, { type DialogProps } from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';

const StyledDialog = styled(MUIDialog)(() => ({
  '& .MuiDialog-paper': {
    // [theme.breakpoints.down('xs')]: {
    //   margin: 0,
    //   width: '100%',
    //   maxWidth: '100%',
    //   height: '100%',
    //   maxHeight: '100%',
    //   borderRadius: 0,
    // },
    // [theme.breakpoints.down('sm')]: {
    //   margin: 0,
    //   width: '100%',
    //   maxWidth: '100%',
    //   height: '100%',
    //   maxHeight: '100%',
    //   borderRadius: 0,
    // },
    // [theme.breakpoints.down('md')]: {
    //   margin: 0,
    //   width: '100%',
    //   maxWidth: '100%',
    //   height: '100%',
    //   maxHeight: '100%',
    //   borderRadius: 0,
    // },
    width: '100%',
  },
}));

interface Props extends DialogProps {
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}
export default function Dialog({ maxWidth, ...props }: Props): React.ReactElement {
  // let muiClasses;
  // if (maxWidth != null) {
  //   muiClasses = {
  //     paper: '',
  //   };
  // }
  return (
    <StyledDialog
      disableEscapeKeyDown={props.disableEscapeKeyDown}
      fullScreen={props.fullScreen}
      fullWidth={props.fullWidth}
      onClose={props.onClose}
      open={props.open}
      PaperProps={props.PaperProps}
      TransitionComponent={props.TransitionComponent}
      transitionDuration={props.transitionDuration}
      maxWidth={maxWidth}
      // classes={muiClasses}
    >
      {props.children}
    </StyledDialog>
  );
}
